import { render, staticRenderFns } from "./AlertPill.vue?vue&type=template&id=466e1588&"
import script from "./AlertPill.vue?vue&type=script&lang=js&"
export * from "./AlertPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports